export default function MaintenanceRouteConfig($stateProvider, gettext) {
  'ngInject';

  let maintPerform = gettext('Performing Maintenance'),
    maintHistory = gettext('Maintenance History'),
    maintDetails = gettext('Details'),
    maintDashboard = gettext('Dashboard'),
    plans = gettext('Plans'),
    plansCreate = gettext('Create');

  $stateProvider
    .state('maintenance', {
      url: '/maintenance',
      template: require('./maintenance.html'),
      controller: 'MaintenanceController',
      redirectTo: 'maintenance.board',
      ncyBreadcrumb: {
        label: "{{'Maintenance' | translate}}"
      },
      requiredFeatures: ['maintenance']
    })
    .state('maintenance.history', {
      url: '/history',
      template: require('./history/history.html'),
      controller: 'MaintenanceHistoryController',
      ncyBreadcrumb: {
        label: "{{'Maintenance History' | translate}}"
      },
      requiredFeatures: ['maintenance']
    })
    .state('maintenance.history-details', {
      url: '/details?serviceRecord={id}',
      template: require('./history/details/details.html'),
      controller: 'MaintenanceHistoryDetailsController',
      ncyBreadcrumb: {
        label: "{{'Details' | translate}}",
        parent: 'maintenance.history'
      },
      requiredFeatures: ['maintenance']
    })
    .state('maintenance.board', {
      url: '/dashboard',
      template: require('./board/board.html'),
      controller: 'MaintenanceBoardController',
      ncyBreadcrumb: {
        label: "{{'Dashboard' | translate}}"
      },
      requiredFeatures: ['maintenance']
    })
    .state('maintenance.board-detail', {
      url: '/dashboard/{id}',
      ncyBreadcrumb: {
        label: "{{'Details' | translate}}",
        parent: 'maintenance.board'
      },
      requiredFeatures: ['maintenance']
    })
    .state('maintenance.plans', {
      url: '/plans',
      template: require('./plans/plans.html'),
      controller: 'MaintenancePlansController',
      ncyBreadcrumb: {
        parent: 'maintenance',
        label: "{{'Plans' | translate}}"
      },
      requiredFeatures: ['maintenance.plans']
    })
    .state('maintenance.createplan', {
      url: '/plans/create',
      template: require('./plans/create/create.html'),
      controller: 'CreatePlanController',
      ncyBreadcrumb: {
        label: "{{'Create New Plan' | translate}}"
      },
      requiredFeatures: ['maintenance.plans.manage', 'maintenance.plans.manage']
    })
    .state('maintenance.plans-detail', {
      url: '/plans/{id}',
      template: require('./plans/details/details.html'),
      controller: 'MaintenancePlansDetailsController',
      redirectTo: 'maintenance.plans-detail.tasks',
      ncyBreadcrumb: {
        label: '{{maintenancePlanData.name}}',
        parent: 'maintenance.plans',
        name: "{{'Detail'| translate}}"
      },
      requiredFeatures: ['maintenance.plans']
    })
    .state('maintenance.plans-detail.tasks', {
      url: '/tasks',
      helpState: 'maintenance.plansdetail',
      template: require('./plans/details/tasks/tasks.html'),
      ncyBreadcrumb: {
        skip: true
      },
      requiredFeatures: ['maintenance.plans']
    })
    .state('maintenance.plans-detail.assets', {
      url: '/assets',
      helpState: 'maintenance.plansdetail',
      template: require('./plans/details/assets/assets.html'),
      ncyBreadcrumb: {
        skip: true
      }
    });
}
